const TRUTHY_VALUES = new Set(['1', 'true', 'on', 'yes']);
const FALSY_VALUES = new Set(['0', 'false', 'off', 'no']);

let cachedBytesOnlyFlag = null;

const normalizeString = (value) => {
  if (value == null) {
    return null;
  }
  try {
    const normalized = String(value).trim();
    return normalized ? normalized : null;
  } catch {
    return null;
  }
};

const parseFlagValue = (value) => {
  if (typeof value === 'boolean') {
    return value;
  }
  const normalized = normalizeString(value);
  if (!normalized) {
    return null;
  }
  const lower = normalized.toLowerCase();
  if (TRUTHY_VALUES.has(lower)) {
    return true;
  }
  if (FALSY_VALUES.has(lower)) {
    return false;
  }
  return null;
};

const readGlobalFlag = (key) => {
  if (typeof globalThis === 'undefined' || !key) {
    return null;
  }
  const sources = [
    globalThis,
    globalThis.__MLS_FLAGS__,
    globalThis.__FEATURE_FLAGS__,
    globalThis.__APP_FLAGS__,
  ];
  for (const source of sources) {
    if (!source) continue;
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      return source[key];
    }
  }
  return null;
};

const readProcessEnv = (key) => {
  if (!key) {
    return null;
  }
  try {
    if (typeof process !== 'undefined' && process?.env && key in process.env) {
      return process.env[key];
    }
  } catch {}
  return null;
};

const readImportMetaEnv = (key) => {
  if (!key) {
    return null;
  }
  let env = null;
  try {
    // eslint-disable-next-line no-new-func
    env = new Function(
      'return (typeof import.meta !== "undefined" && import.meta && import.meta.env) ? import.meta.env : null;',
    )();
  } catch {}
  if (env && key in env) {
    return env[key];
  }
  return null;
};

const FLAG_KEYS = [
  'MLS_WORKER_BYTES_ONLY',
  'REACT_APP_MLS_WORKER_BYTES_ONLY',
  'VITE_MLS_WORKER_BYTES_ONLY',
];

export const isWorkerBytesOnlyEnabled = () => {
  if (cachedBytesOnlyFlag != null) {
    return cachedBytesOnlyFlag;
  }

  for (const key of FLAG_KEYS) {
    const globalValue = parseFlagValue(readGlobalFlag(key));
    if (globalValue != null) {
      cachedBytesOnlyFlag = globalValue;
      return cachedBytesOnlyFlag;
    }
  }

  for (const key of FLAG_KEYS) {
    const envValue = parseFlagValue(readProcessEnv(key));
    if (envValue != null) {
      cachedBytesOnlyFlag = envValue;
      return cachedBytesOnlyFlag;
    }
  }

  for (const key of FLAG_KEYS) {
    const metaValue = parseFlagValue(readImportMetaEnv(key));
    if (metaValue != null) {
      cachedBytesOnlyFlag = metaValue;
      return cachedBytesOnlyFlag;
    }
  }

  cachedBytesOnlyFlag = false;
  return cachedBytesOnlyFlag;
};
